const parseDeliveryDate = (value) => {
  if (!value) return null;
  let date;
  if (value?.toDate) {
    date = value.toDate();
  } else if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    date = new Date(`${value}T00:00:00`);
  } else {
    date = new Date(value);
  }
  if (isNaN(date.getTime())) return null;
  date.setHours(0, 0, 0, 0);
  return date;
};

/**
 * Teslimat tarihine göre geciken / bugün / yarın / bu hafta grupları oluşturur.
 * @param {Array<{ id, name, deliveryDate, phone?, address?, dealerName?, type? }>} entries
 */
export const buildDeliveryReminders = (entries = []) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);

  const weekEnd = new Date(today);
  weekEnd.setDate(weekEnd.getDate() + 7);

  const deliveryData = {
    overdue: [],
    today: [],
    tomorrow: [],
    thisWeek: []
  };

  entries.forEach((entry) => {
    const deliveryDate = parseDeliveryDate(entry.deliveryDate);
    if (!deliveryDate) return;

    const info = {
      ...entry,
      daysLeft: Math.ceil((deliveryDate - today) / (1000 * 60 * 60 * 24))
    };

    if (deliveryDate < today) {
      info.daysOverdue = Math.abs(info.daysLeft);
      deliveryData.overdue.push(info);
    } else if (deliveryDate.getTime() === today.getTime()) {
      deliveryData.today.push(info);
    } else if (deliveryDate.getTime() === tomorrow.getTime()) {
      deliveryData.tomorrow.push(info);
    } else if (deliveryDate < weekEnd) {
      deliveryData.thisWeek.push(info);
    }
  });

  deliveryData.overdue.sort((a, b) => b.daysOverdue - a.daysOverdue);
  return deliveryData;
};

export const hasDeliveryReminders = (reminders) =>
  reminders.overdue.length > 0 ||
  reminders.today.length > 0 ||
  reminders.tomorrow.length > 0 ||
  reminders.thisWeek.length > 0;
